import '../typedefs'
import http from '@/http'

export default {
    /**
     * @param {SearchQuery} query
     * @returns {Promise<void>}
     */
    async searchSuppliers (query) {
        try {
            const response = await http.get('/products/suppliers', {
                params: query
            })

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {ProductQuery} data
     * @returns {Promise<void>}
     */
    async showSupplier (data) {
        try {
            const response = await http.get(`/products/suppliers/${data.id}`)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {Supplier} data
     * @returns {Promise<void>}
     */
    async createSupplier (data) {
        try {
            const response = await http.post('/products/suppliers', data)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {Supplier} data
     * @returns {Promise<void>}
     */
    async updateSupplier (data) {
        try {
            const response = await http.put(`/products/suppliers/${data.id}`, data)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {Supplier} data
     * @returns {Promise<void>}
     */
    async removeSupplier (data) {
        try {
            const response = await http.delete(`/products/suppliers/${data.id}`)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
